<script setup>

import { computed } from 'vue'
import store from '@/store'
import router from '@/router'
import Icon from "@/components/Icon/Icon.vue"
import AutoLogout from "@/components/connexion/AutoLogout.vue"
import FirstConnexion from "@/components/connexion/FirstConnexion.vue"

const currentUser = computed(() => {
    return store.state.auth.user
})

const logOut = () => {
    store.dispatch('auth/logout')

    if(localStorage.getItem('account_name')) {
        router.push({name: 'login_account'})
    } else {
        router.push({name: 'login'})
    }
}

</script>

<template>

<div class="font-primary w-full mx-auto overflow-hidden">
  <div class="block">
    <AutoLogout />
    <FirstConnexion />
    <nav class="bg-neutral-800 text-white sticky navbar navbar-expand navbar-dark bg-dark flex flex-column justify-between p-2">
      <div class="my-auto">
        <a href="https://www.lune-et-pistache.fr/">Lune et Pistache</a>
      </div>
      <!--z-[2000] top-0-->
      <!--div v-if="currentUser && currentAccountName" class="navbar-nav flex flex-column"-->
      <div class="navbar-nav flex flex-column m-auto">
        <div>
          <router-link :to="{name: 'main'}" class="nav-link hover:underline">
            Gestion immobilière
          </router-link>
        </div>
      </div>
      
      <div>
        <div v-if="currentUser" class="navbar-nav flex gap-4">
          <div class="my-2 w-4">
            <router-link
              :to="{name: 'import_export'}"
              title="Services"
            >
              <Icon name="services" :size="30" color="white" />
            </router-link>
          </div>
          <div class="my-2 w-4">
            <router-link
              :to="{name: 'setting'}"
              title="Configuration"
            >
              <Icon name="setting" :size="30" color="white" />
            </router-link>
          </div>
          <div class="my-2 w-4">
            <a class="hover:cursor-pointer" @click.prevent="logOut" title="Se déconnecter">
              <Icon name="exit" :size="30" color="white" />
            </a>
          </div>
        </div>
      </div>
    </nav>

    <div>
      <router-view />
    </div>
  </div>
</div>

</template>
